export const evidenceHero = {
  eyebrow: '证据中心',
  title: '让每一项成果可被看见',
  titleHighlight: '资质 · 文件 · 技术 · 生态 · 数据',
  subtitle: '华辉数智技术与九畴云市项目的资质、文件、技术成果、合作生态与实时数据，集中呈现、可核可查。',
  desc: '官网所展示内容均属于项目对接、规划或申报方向；取得相关资质、入库或认定后方可使用相应官方身份表述。',
};

export const qualifications = [
  {
    icon: 'ri-file-list-3-line',
    title: '企业主体资质',
    desc: '依法登记注册的企业法人主体，具备技术服务与系统交付资质。',
  },
  {
    icon: 'ri-verified-badge-line',
    title: '人工智能应用服务商',
    tag: '规划申报',
    desc: '面向工信厅科函〔2026〕414 号方向，推进人工智能应用服务商入库与认定。',
  },
  {
    icon: 'ri-team-line',
    title: '服务团联合单位',
    tag: '生态协同',
    desc: '列入人工智能应用服务团联合单位，承担智能体、数字货架、系统集成与设备生产。',
  },
];

export const projectFiles = [
  {
    icon: 'ri-file-text-line',
    title: '项目文件',
    desc: '九畴云市项目整体规划、建设目标与实施路径的纲领性文件。',
  },
  {
    icon: 'ri-file-list-3-line',
    title: '首发方案',
    desc: '0# 帝星数商综合体首发方案，明确万村万店振兴乡村首发定位。',
  },
  {
    icon: 'ri-map-2-line',
    title: '复制路线',
    desc: '0#→1#→N# 全国复制路线与千县万村网络规划文件。',
  },
  {
    icon: 'ri-scales-3-line',
    title: '合规文件',
    desc: '项目说明、合规声明与政策申报方向的衔接文件。',
  },
];

export const techAchievements = [
  {
    icon: 'ri-robot-2-line',
    title: 'TOMA 智能体',
    desc: 'AI 交互入口，承载美食社交、健康管家与数字服务。',
  },
  {
    icon: 'ri-store-2-line',
    title: '数字货架',
    desc: '商品数字化、交易入口与数据回流的系统实现。',
  },
  {
    icon: 'ri-qr-code-line',
    title: 'ePin 数字身份',
    desc: '一物一码、品质认证与溯源存证的数字化能力。',
  },
  {
    icon: 'ri-flow-chart',
    title: '智能清分',
    desc: '一笔交易一条数据链，多方协同自动结算。',
  },
];

export const ecosystemPartners = [
  { name: '慈商科技', role: '产业运营协同' },
  { name: '三明词元', role: 'AI 模型与词元服务' },
  { name: '华辉数智技术', role: '技术交付与系统实现', highlight: true },
  { name: '纽盾科技', role: '安全治理与合规' },
  { name: '欣阳通力', role: '设备生产与供应链' },
];

export const liveStats = [
  { value: '4万+', label: '帝星存量会员', trend: '种子用户' },
  { value: '1000', label: '首批消费卡', trend: '已发行' },
  { value: '10—20', label: '首批数字货架商品', trend: '上架中' },
  { value: '99', label: '云创客招募', trend: '启动中' },
  { value: '5', label: '生态合作伙伴', trend: '协同共建' },
  { value: '3秒', label: '红包到账目标', trend: '项目设定' },
];

export const fileList = [
  { id: 'HH-001', name: '企业法人营业执照', type: '资质证照', category: '资质', status: '已核验', date: '2026-01', desc: '华辉数智技术企业主体登记资质，证明其作为技术服务与系统交付的企业法人主体。' },
  { id: 'HH-002', name: '人工智能应用服务商申报', type: '资质申报', category: '资质', status: '申报中', date: '2026-03', desc: '面向工信厅科函〔2026〕414 号方向的人工智能应用服务商入库与认定申报。' },
  { id: 'JC-001', name: '九畴云市项目规划书', type: '项目文件', category: '项目', status: '已归档', date: '2026-02', desc: '九畴云市乡村数字经济操作系统整体规划文件。' },
  { id: 'JC-002', name: '0#帝星数商综合体首发方案', type: '项目文件', category: '项目', status: '已归档', date: '2026-02', desc: '0# 首发方案，明确万村万店振兴乡村首发定位与首笔交易闭环。' },
  { id: 'JC-003', name: '千县万村复制路线文件', type: '项目文件', category: '项目', status: '已归档', date: '2026-02', desc: '0#→1#→N# 全国复制路线与千县万村网络规划。' },
  { id: 'TC-001', name: 'TOMA智能体技术成果', type: '技术成果', category: '技术', status: '已交付', date: '2026-02', desc: 'TOMA 智能体 AI 交互入口，承载美食社交、健康管家与数字服务。' },
  { id: 'TC-002', name: '数字货架系统说明', type: '技术成果', category: '技术', status: '已交付', date: '2026-02', desc: '数字货架商品数字化、交易入口与数据回流系统。' },
  { id: 'CM-001', name: '项目说明与合规声明', type: '合规文件', category: '合规', status: '已发布', date: '2026-03', desc: '九畴云市项目说明与合规声明，明确项目规划与申报方向。' },
];